import { render, staticRenderFns } from "./reviewer-info.vue?vue&type=template&id=5db9e16a&scoped=true"
import script from "./reviewer-info.vue?vue&type=script&lang=js"
export * from "./reviewer-info.vue?vue&type=script&lang=js"
import style0 from "./reviewer-info.vue?vue&type=style&index=0&id=5db9e16a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db9e16a",
  null
  
)

export default component.exports